<section class="user-profile-feedback-subpage profile-section"
         [class.mobile]="deviceService.isMobile()"
         [class.tablet]="deviceService.isTablet()"
         rel="reviews">
  <app-title *ngIf="meetingReviews.items.length || isMe" [title]="'user-profile.reviews'"></app-title>

  <ng-container *ngIf="meetingReviews.items.length || isMe">
    <ng-template [ngIf]="meetingReviews.loaded && meetingReviews.items.length">
      <div class="section-sorter">
        <ul class="sorter-list">
          <li class="sorter medium"
              [class.selected]="order === 'updatedAt'"
              (click)="setReviewsSortOrder('updatedAt')">{{ 'user-profile.sorter.date' | translate }}</li>
          <li class="sorter medium"
              [class.selected]="order === 'rating'"
              (click)="setReviewsSortOrder('rating')">{{ 'user-profile.sorter.rating' | translate }}</li>
        </ul>
      </div>
      <div class="section-body">
        <div class="review-wrap-list">
          <app-meeting-review-form
            *ngFor="let meetingReview of meetingReviews.items; trackBy: trackReviewByFn"
            [meetingReview]="meetingReview">
          </app-meeting-review-form>
        </div>
      </div>

      <loading-line *ngIf="meetingReviews.loading" height="40px" width="100%"></loading-line>
      <span inViewport (inViewportAction)='onInViewportBottomChange($event)'></span>
    </ng-template>
    <ng-template [ngIf]="meetingReviews.loaded && !meetingReviews.items.length">
      <app-empty *ngIf="isMe" [empty]="emptyFeedbackObj"></app-empty>
    </ng-template>
  </ng-container>

</section>
